import * as React from "react";
import { Form } from "antd";
import SimpleFormItem from "./SimpleFormItem";

const SimpleForm = ({
    getFieldDecorator,      
    translate, 
    formItems,          
    rowData
} : {
    getFieldDecorator: any,
    translate: any,
    formItems: any,
    rowData?: any
}) => {
    return (
        <Form>
            {formItems.map((item) => {
                return <SimpleFormItem 
                            key={item.name}
                            getFieldDecorator={getFieldDecorator}
                            translate={translate}
                            item={item}
                            rowData={rowData}
                        />
            })}
        </Form>
    )
}

export default SimpleForm;
